import api from '@/services/api'

export default {
  actions: {
    async getAchievements({ commit }, data) {
      try {
        const query = new URLSearchParams(data)
        const response = await api.get(`/quiz/achievements?${query}`)
        return response && response.data ? response.data : []
      } catch (error) {
        throw error
      }
    },
  },
}
